import { FC } from "react";
import InstructionCards from "../../InstructionCards/InstructionCards";

type Props = {
  usageInstructions: string;
  termsAndConditions: string;
};

const InstructionsMob: FC<Props> = ({ usageInstructions, termsAndConditions }) => {
  return <InstructionCards usageInstructions={usageInstructions} termsAndConditions={termsAndConditions} />;
};

export default InstructionsMob;
